<script lang="ts" setup>
import PageHeader from '@/components/header/PageHeader.vue'
import PageFooter from '@/components/footer/PageFooter.vue'
import { ModalTypes } from '@/helper/ModalTypes'
import i18n from '@/helper/Translations'
import { modalService } from '@/services/modals/ModalService'
import ModalParams from '@/services/modals/ModalParams'
import { tagPageView } from '@/helper/analytics'
import { onMounted } from 'vue'
import { setMetaTitle } from '@/helper/tools'

onMounted(async () => {
  tagPageView('/login_failed')

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  i18n.global.locale = navigator.language.substring(0, 2)
  setMetaTitle('')
  await modalService.showModal(new ModalParams(ModalTypes.LOGIN_FAILURE))
})
</script>

<template>
  <div>
    <PageHeader />
    <div class="main-wrapper" />
    <PageFooter />
  </div>
</template>
